<template>
  <div class="flex" style="position: relative;">
    <Goback :title="'返回首页'" :isBack="true" @goBackFunc="goBackFunc" style="position: absolute;left: 20%;top:5%;z-index: 10;"></Goback>
    <Overview style="position: absolute;left: 0px;top: 0px;z-index: 10;"/>
    <singleSite/>
    <div class="flex flex-direction" style="position: absolute;right: 0px;top: 0px;">
      <SiteType></SiteType>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/singleSite/siteOverview";
import singleSite from "@/views/singleSite/singleSite";
import SiteType from "@/views/singleSite/siteType.vue";
export default {
  data () {
    return {
		
    };
  },
  components: {
    Overview,
    singleSite,
    SiteType,
    Goback
  },
  props: {
    
  },
  watch: {
    
  },
  methods: {
    goBackFunc(){
      this.$router.push({
          path: '/nationwideSite',
          query: {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>